// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../home/tiger/.nvm/versions/node/v12.4.0/lib/node_modules/@ies/eden/node_modules/@ies/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2KZovIvah79VzqoyLtJ9Lf{display:flex;align-items:center}._3Fc9JpstqXuI0TDw6PZzVc{flex-direction:column}._2pDwCoQlrCQI6J-MK_Tf11{width:2.28rem;height:2.28rem;margin-right:.80rem;border-radius:.12rem;background:#e5e5e6}._3RboIPR76Rmc1jixmY-4A6{display:flex;flex-direction:column;align-items:center}._3CGrBGz9Q7D6UbzzHj6YGM{font-size:18px;line-height:21px;font-weight:500;color:#161722}._26E3gKXemAWQn2pxi6pEi8{height:.40rem;width:100%}._1kxas6T5pFYDQewAuEkakT{width:0.02rem;height:.28rem;background:#e5e5e6}._8GZ59TkuyBv0eTKwtnkRl{width:100%}._3zSRtqY7NFZPXKAcqcY2nF{flex:1;display:flex;justify-content:space-between;align-items:center}._3tzMSz_rSMi7vqfdtbU77_{font-size:14px;line-height:17px;color:#97999c}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": "_2KZovIvah79VzqoyLtJ9Lf",
	"column": "_3Fc9JpstqXuI0TDw6PZzVc",
	"cover": "_2pDwCoQlrCQI6J-MK_Tf11",
	"section": "_3RboIPR76Rmc1jixmY-4A6",
	"count": "_3CGrBGz9Q7D6UbzzHj6YGM",
	"place": "_26E3gKXemAWQn2pxi6pEi8",
	"line": "_1kxas6T5pFYDQewAuEkakT",
	"info": "_8GZ59TkuyBv0eTKwtnkRl",
	"wrap": "_3zSRtqY7NFZPXKAcqcY2nF",
	"message": "_3tzMSz_rSMi7vqfdtbU77_"
};
module.exports = ___CSS_LOADER_EXPORT___;
